import { getPaginatedResult } from "../utils/ComponentUtil";


class InternshipsAPI {
    static internship = {
        id: 123123123213,
        title: 'Brand Kit And Logo Design Work',
        name: 'Graphics Design',
        postedOn: '01 June 2022',
        stipend: '₹ 10000 - ₹ 15000/Per Month',
        duration: '2 Months',
        members: '10',
        slotsRemaining: '5',
        skillsNeeded: ['Photoshop', 'Illustrator', 'CorelDraw', 'Figma'],
        about: 'Graphic designers make use of computer software or make designs by hand for the creation of visual concepts for communicating their ideas for informing others, inspiring them, or attracting consumers. They generally make the overall design for ads, corporate reports, magazines, and brochures.',
        advantages: [
            'Do you have a bulk order or a small order? Don\'t worry; I will be your ideal choice in that case as I have enough experience to deliver quality work efficiently. Also, my experience allows me to deliver all the work in just 24 hours of ordering. Speed is my first quality, so you can be free from worries about any work delay.',
            'Also, I will create designs that will enhance the look of your website or social media posts and attract new engagements. You can hire me for poster designing, website design, brochure design or simple graphic design work; I am open to all the possible working opportunities with my clients.',
            '<b>Note:</b> Please drop me a message if you have any concerns about my services or work method. I will be happy to schedule a meeting with you for discussing all the concerns and queries.'
        ],
        faqs: [
            {
                question: 'Are You Able To Deliver Graphics Faster than 24 Hours?',
                answer: 'All of my work is delivered within 24 hours of placing the order. If you need your work to be done on an urgent basis, then you can opt for a 12-hour plan as well. However, the charges might be slightly higher than the normal gig.'
            },
            {
                question: 'Do You Also Create Flyers And Social Media Graphic?',
                answer: 'Yes, I can help you in creating all types of graphics to fulfil your purposes. You can purchase different packages and get your work done in a minimum of 24 hours. I will provide you with a JPEG format of the graphic, but if you want, I can send you a print-ready PDF format without any additional charges.'
            },
            {
                question: 'Do You Also Create Flyers And Social Media Graphic?',
                answer: 'Yes, I can help you in creating all types of graphics to fulfil your purposes. You can purchase different packages and get your work done in a minimum of 24 hours. I will provide you with a JPEG format of the graphic, but if you want, I can send you a print-ready PDF format without any additional charges.'
            }
        ]

    };
    static internships = [
        {...this.internship, title:'Review Writing Jobs', name: 'Daily Jobs', to: '/internships/custom/review-writing'},
        {...this.internship, title:'Copy Paste Jobs', name: 'Daily Jobs', to: '/internships/custom/copy-paste'},
        {...this.internship, title:'Proof reading', name: 'Daily Jobs', to: '/internships/custom/proof-reading'},
        {...this.internship, title:'New Proof reading', name: 'Daily Jobs', to: '/internships/custom/new-proof-reading'},
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        this.internship,
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        {...this.internship, skillsNeeded: ['Illustrator', 'CorelDraw', 'Photoshop', 'Figma', 'CorelDraw']},
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
        this.internship,
    ];

    static getInternshipDetails = (id) => {
        return {
            internship: this.internship,
            similarInternships: this.internships.splice(0, 3)
        }
    }
    static fetchTopTalents = (limit = 3) => {
        //change this api calling logic with actual API
        return this.internships.splice(0, limit);
    }
    static fetchInternships = (offset = 1, searchInput = '', limit = 30) => {
        //change this api calling logic with actual API
        return getPaginatedResult(offset, this.internships, limit);
    }
}
export default InternshipsAPI;